import { createSlice } from "@reduxjs/toolkit";

export const searchInitialState = {
  search: {
    result: null,
    error: null,
  },
  filter: {
    result: null,
    error: null,
    filters: {
      vivo: "",
      committeeCredit: "",
      attendanceHistory: "",
      socials: "",
      workshops: "",
      negative: "",
      payment: "",
      //TODO: chapterInvolvement is for fundRaiser. should be replaced with new column called fundRaiser in new semester.
      chapterInvolvement: "",
    },
  },
};

export const sliceName = "search";
export const searchSlice = createSlice({
  name: sliceName,
  initialState: searchInitialState,
  reducers: {
    setSearchResult: (state, action) => {
      state.search.result = action.payload;
    },
    setError: (state, action) => {
      state.search.error = action.payload;
    },
    setFilterResult: (state, action) => {
      state.filter.result = action.payload;
    },
    setFilterVivo: (state, action) => {
      state.filter.filters.vivo = action.payload;
    },
    setFilterCommitteeCredit: (state, action) => {
      state.filter.filters.committeeCredit = action.payload;
    },
    setFilterAttendanceHistory: (state, action) => {
      state.filter.filters.attendanceHistory = action.payload;
    },
    setFilterSocials: (state, action) => {
      state.filter.filters.socials = action.payload;
    },
    setFilterWorkshops: (state, action) => {
      state.filter.filters.workshops = action.payload;
    },

    setFilterNegative: (state, action) => {
      state.filter.filters.negative = action.payload;
    },

    setFilterPayment: (state, action) => {
      state.filter.filters.payment = action.payload;
    },

    setFilterChapterInvolvement: (state, action) => {
      state.filter.filters.chapterInvolvement = action.payload;
    },
    setFilterError: (state, action) => {
      state.filter.error = action.payload;
    },
  },
});

export const {
  setFilterError,
  setSearchResult,
  setError,
  setFilterResult,
  setFilterVivo,
  setFilterCommitteeCredit,
  setFilterAttendanceHistory,
  setFilterChapterInvolvement,
  setFilterPayment,
  setFilterNegative,
  setFilterWorkshops,
  setFilterSocials,
} = searchSlice.actions;
export const selectSearchResult = (state) => state[sliceName].search.result;
export const selectError = (state) => state[sliceName].search.error;
export const selectFilterResult = (state) => state[sliceName].filter.result;
export const selectFilterVivo = (state) => state[sliceName].filter.filters.vivo;
export const selectFilterCommitteeCredit = (state) =>
  state[sliceName].filter.filters.committeeCredit;

export const selectFilterAttendanceHistory = (state) =>
  state[sliceName].filter.filters.attendanceHistory;

export const selectFilterSocials = (state) =>
  state[sliceName].filter.filters.socials;

export const selectFilterWorkshops = (state) =>
  state[sliceName].filter.filters.workshops;

export const selectFilterNegative = (state) =>
  state[sliceName].filter.filters.negative;

export const selectFilterPayment = (state) =>
  state[sliceName].filter.filters.payment;

export const selectFilterChapterInvolvement = (state) =>
  state[sliceName].filter.filters.chapterInvolvement;
